import { config } from '@shopee-user/platform';
import { EnvConfig, LocaleDomainSuffixConfig } from '@shopee-user/global';

export enum IvsEventType {
  Login = 34,
  OneCredentialLogin = 53,
}

const { ENV, LOCALE } = config;

export const IVS_BASE_URL = `https://verify.${EnvConfig[ENV].subDomainPrefix}spx.${LocaleDomainSuffixConfig[LOCALE]}`;

export const IVS_BASE_REGEX = /^verify\.(test\.|uat\.|staging\.)?spx\.(co\.(id|th)|com\.(my|br|mx|co|ar)|sg|vn|tw|ph|cl|pl|es)$/;
